import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button } from '@mui/material';

const WorkspaceConfirmDialog = ({ open, action, onConfirm, onCancel }) => {
  return (
    <Dialog open={open} onClose={onCancel}>
      <DialogTitle>{action?.label || 'Confirm'}</DialogTitle>
      <DialogContent>
        <DialogContentText>{action?.confirmMessage || 'Are you sure?'}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel}>Cancel</Button>
        <Button onClick={onConfirm} variant="contained" autoFocus>Confirm</Button>
      </DialogActions>
    </Dialog>
  );
};

export default WorkspaceConfirmDialog;
